var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9378 9.6614C12.9378 10.0472 12.8618 10.4292 12.7142 10.7856C12.5665 11.1421 12.3501 11.4659 12.0773 11.7387C11.8045 12.0115 11.4807 12.2279 11.1243 12.3755C10.7678 12.5232 10.3858 12.5992 10 12.5992C9.61423 12.5992 9.23222 12.5232 8.87579 12.3755C8.51936 12.2279 8.19551 12.0115 7.92271 11.7387C7.64991 11.4659 7.43352 11.1421 7.28588 10.7856C7.13824 10.4292 7.06226 10.0472 7.06226 9.6614C7.06226 8.88226 7.37177 8.13502 7.92271 7.58409C8.47365 7.03315 9.22088 6.72363 10 6.72363C10.7792 6.72363 11.5264 7.03315 12.0773 7.58409C12.6283 8.13502 12.9378 8.88226 12.9378 9.6614Z",
    stroke: "#6860EE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.10693C14.0878 2.10693 17.5543 5.49208 17.5543 9.59909C17.5543 13.7707 14.0315 16.6993 10.7782 18.6894C10.5406 18.8231 10.2726 18.8933 10.0001 18.8933C9.72749 18.8933 9.45951 18.8231 9.22198 18.6894C5.97364 16.6808 2.4458 13.7867 2.4458 9.59993C2.4458 5.49208 5.91237 2.10693 10.0001 2.10693Z",
    stroke: "#6860EE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.6a3a8c6e2e69695dbd6d3f6c004be633.svg";
export { ForwardRef as ReactComponent };